import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useFetchGet } from "Services/api";
import NivoBar from "Components/Stats/Charts/NivoBar";
import Margin from "Components/Stats/Margin";
import { getUsersCountByRegistrationDateData } from "Components/Stats/Data/Utilisateurs/Inscriptions";

/**
 * Composant 'UsersCountByRegistrationDate'.
 *
 * Récupère les données du nombre d'inscrits par jour, par role, et les formate sous un graphique en barres.
 *
 * @param {Object[]} props
 * @param  {Object} props.auth - Les informations d'authentification de l'utilisateur (depuis Redux).
 * @param  {string} props.universityName - Le nom de l'université actuelle.
 * @returns {JSX.Element} Le graphique du nombre d'inscrits par jour, par role.
 */
const UsersCountByRegistrationDate = (props) => {
  const [graphData, setGraphData] = useState([]);

  const usersCountByRegistrationDate = useFetchGet(
    "/users/stats/count/registration_date",
    props.auth.token
  );

  useEffect(() => {
    if (usersCountByRegistrationDate.loaded) {
      setGraphData(
        getUsersCountByRegistrationDateData(usersCountByRegistrationDate.data)
      );
    }
  }, [usersCountByRegistrationDate.loaded]);

  return (
    <React.Fragment key={graphData}>
      <NivoBar
        data={graphData}
        colors="pastel2"
        legendYAxis="Nombre d'inscrits"
        keysNames={["Étudiants", "Alumni"]}
        indexName="Date"
        displayFill={false}
        title={
          "Nombre journalier de nouveaux inscrits, sur le dernier mois, sur l'université " +
          props.universityName
        }
        displayPercentage
      />
      <Margin position="bottom" size="xs" />
    </React.Fragment>
  );
};

UsersCountByRegistrationDate.propTypes = {
  universityName: PropTypes.string,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersCountByRegistrationDate);
